export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-[800px] mx-auto text-center">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-400 mb-3">ABOUT</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">关于我们</h2>
            <div className="mt-8 space-y-4 text-sm md:text-base text-foreground-400 leading-relaxed">
              <p>
                成全影院是一个致力于为影迷提供<strong className="text-foreground-200 font-semibold">最新电影、新剧上线和热门综艺</strong>的免费在线观看平台。我们深知每一位观众对优质内容和高品质观影体验的追求，因此从内容采集、画质优化到播放流畅度，每一个环节都精益求精。
              </p>
              <p>
                平台汇聚超过两万部影视资源，涵盖动作、悬疑、爱情、喜剧、科幻、动漫等全类型题材，每日与各大平台<strong className="text-foreground-200 font-semibold">同步更新</strong>，确保您第一时间看到想看的作品。成全影院采用先进的视频传输技术，支持多清晰度自适应切换，无论在电脑、平板还是手机上，都能享受<strong className="text-foreground-200 font-semibold">高清不卡顿</strong>的极致观影体验。
              </p>
              <p>
                成全影院始终秉持"用户至上"的理念，持续丰富内容库，优化播放体验，让每一位访问者都能在这里找到属于自己的光影世界。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}